"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketErrorMessage = void 0;
var joi_1 = __importDefault(require("joi"));
var message_1 = require("../message");
var SocketErrorMessageRaw = message_1.createMessage('socket-error', joi_1.default.any());
exports.SocketErrorMessage = Object.assign(function (payload, requestId) {
    var message = SocketErrorMessageRaw(payload);
    return __assign(__assign({}, message), { requestId: requestId });
}, SocketErrorMessageRaw);
